<template>
  <div class="d-flex flex-column px-2">
    <div
      class="d-flex align-center px-0 elevation-0 mb-4"
      style="background-color: inherit;"
    >
      <span class="font-rubik pr-5 secondary--text text--lighten-3">{{
        currentTitle
      }}</span>
      <v-spacer></v-spacer>
      <v-list-item-avatar
        class="subheading bg-purple text-white mr-0"
        size="30"
      >
        <v-avatar
          class="white--text text-capitalize "
          size="30px"
          color="amber"
        >
          <span style="font-size: 20px">
            {{ step }}
          </span>
        </v-avatar>
      </v-list-item-avatar>
    </div>

    <div>
      <img src="/img/logo_small.png" height="38px" />
    </div>

    <section>
      <v-window v-model="step" touchless>
        <v-window-item :value="1">
          <p class="auth-subheading pt-3 font-weight-bold">
            Welcome, continue to the
            <br />colorful world <br />of
            <span class="color-purple">Bubbl</span>.
          </p>

          <v-form v-model="emailValid" ref="form" @submit.prevent="submitEmail">
            <v-text-field
              label="Enter Email"
              v-model="email"
              type="text"
              :disabled="loading"
              autofocus
              hint="Enter the first part of your AUN email (firstname.lastname)"
              color="#795fdc"
            ></v-text-field>
          </v-form>

          <v-btn
            class="text-white mt-2"
            @click="submitEmail"
            :loading="loading"
            dark
            large
            color="#795fdc"
            >NEXT</v-btn
          >

          <div class="text-center">
            <p class="subtitle-2 text-light text-left lighten mt-5 pt-3 mb-2">
              You will recieve a token, enter the token in the next step
            </p>
          </div>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text class="px-0">
            <v-form
              v-model="tokenValid"
              ref="tokenForm"
              @submit.prevent="verifyToken"
            >
              <v-text-field
                label="Token"
                autofocus
                v-model="token"
                type="text"
                color="#795fdc"
              ></v-text-field>
            </v-form>
            <div class="d-flex flex-row">
              <v-btn
                class="text-white back-button purple-outline"
                style="background: transparent"
                large
                @click="back"
              >
                <v-icon class="color-purple" style="color: #795FDC!important">
                  {{ mdiArrowLeft }} </v-icon
                >Back
              </v-btn>
              <v-btn
                class="text-white ml-3"
                @click="verifyToken"
                :loading="loading"
                dark
                large
                color="#795fdc"
                >VERIFY</v-btn
              >
            </div>

            <div class="text-left">
              <p class="subtitle-2 text-light lighten mt-5 mb-2">
                Please enter the token you received
              </p>
            </div>
          </v-card-text>
        </v-window-item>
        <v-window-item :value="3">
          <div class="pa-4 text-center">
            <div
              class="d-flex text-center justify-center align-center"
              style="height: 500px"
            >
              <div class="text-center">
                <p class="mx-auto mt-3" style="font-size: 50px !important;">
                  🎉
                </p>
                <span
                  class="title d-block text-light lighten mt-5 mb-2"
                  style="width: 200px"
                  >Welcome to Bubbl!</span
                >
                <p></p>
                <p>Taking you to Bubbl :)</p>
              </div>
            </div>
            <v-progress-linear
              color="#795fdc"
              :value="countdown"
              active
              top
              absolute
              title="Taking you to your feed..."
            ></v-progress-linear>
          </div>
        </v-window-item>
      </v-window>
    </section>

    <div class="auth-footer"></div>
    <v-snackbar
      :color="toast.style"
      v-model="toast.show"
      :timeout="5000"
      bottom
      >{{ toast.message }}</v-snackbar
    >
  </div>
</template>

<script>
import http from '@/plugins/http';
// icons
import { mdiArrowLeft } from '@mdi/js';

export default {
  name: 'Entry',
  data: () => ({
    step: 1,
    emailValid: true,
    tokenValid: true,
    loading: false,
    email: '',
    token: '',
    userToken: '',
    countdown: 0,
    username: '',
    toast: {
      style: '',
      show: false,
      message: ''
    },
    // icons
    mdiArrowLeft
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return 'Your Email';
        case 2:
          return 'Verify Token';
        default:
          this.count();
          return 'Verified ✅';
      }
    }
  },
  methods: {
    submitEmail() {
      this.loading = true;
      // Native form submission is not yet supported
      http
        .post('/auth/email/', {
          email: this.email.trim() + '@aun.edu.ng'
        })
        .then(response => {
          this.loading = false;
          this.step++;
          console.log('Response => ', response.data);
        })
        .catch(response => {
          this.toast.message = "Couldn't post email, please try again";
          this.toast.style = 'error';
          this.toast.show = true;
          console.log('Error => ', response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyToken() {
      this.loading = true;
      // Native form submission is not yet supported
      http
        .post('/auth/token/', {
          token: this.token,
          email: this.email.trim() + '@aun.edu.ng'
        })
        .then(response => {
          this.loading = false;
          this.step++;
          this.userToken = response.data;

          this.$store.dispatch('SET_TOKEN', response.data.token);
          this.$store.dispatch('TOGGLE_LOGGEDIN');
          console.log('Response => ', response.data);
          if (this.$gtag) {
            this.$gtag.event('token_verified', { event_label: 'Google' });
          }
        })
        .catch(response => {
          this.toast.message = 'Couldn\t verify token, please try again';
          this.toast.style = 'error';
          this.toast.show = true;
          console.log('Error => ', response);
          if (this.$gtag) {
            this.$gtag.event('error_verifying_token', {
              event_label: 'Google'
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeUsername() {
      this.loading = true;
      // Native form submission is not yet supported
      http
        .post('/auth/email/', {
          email: this.email
        })
        .then(response => {
          this.loading = false;
          this.step++;
          console.log('Response => ', response.data);
        })
        .catch(response => {
          console.log('Error => ', response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      this.step--;
    },
    count() {
      if (this.countdown < 100) {
        console.log('Inside count!');
        this.countdown += 25;
        setTimeout(() => {
          this.count();
        }, 2000);
        if (this.countdown == 100) {
          // If there's a return to...
          const returnTo = window.localStorage.getItem('bubbl_returnTo');

          window.localStorage.removeItem('bubbl_returnTo');

          this.$router.push(returnTo || '../');
        }
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.auth-icon {
  display: block;
  margin: 20px 0px;
}
.auth-subheading {
  font-size: 24px;
  color: #000000;
  line-height: 1.2;
}

.small-text {
  font-style: normal;
  font-weight: 350;
  font-size: 16px;
  line-height: 19px;

  color: #777777;
}

.small-text a {
  text-decoration: none;

  color: rgb(61, 58, 58);
}

.auth-textfield {
  position: absolute;
  /* width: 100%; */
  height: 70px;
  left: 24px;
  top: 274px;
  font-size: 16px;
  line-height: 24px;
}

.text-white {
  color: white !important;
}

.auth-footer {
  background: url('https://i.ibb.co/s9YGcYP/edited-sharon-mccutcheon-TZZw-C-xs-Cl-Y-unsplash.jpg');
  background-origin: border-box;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: fixed;
  width: 100%;
  height: 77px;
  left: 0px;
  bottom: 0px;
}

.v-toolbar .v-toolbar__extension {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.v-icon {
  color: black !important;
}

.back-button {
  border: 1px solid black;
  color: #795fdc !important;
}

/* .logo-div {
  margin-top: 1.5rem;
  padding: 0rem 0.5rem;
} */
</style>
